import {bp} from './namespace.js';
import './sessionstate.js';

$.extend(true, bp, {
  dashboard: (function () {
    return {
      set_advertisement_state: function (advertisement_pk) {
        $('#estate_offer_item_' + advertisement_pk + ' .advertisement-state').load('/dashboard/pand/status/' + advertisement_pk + '/');
      },
      remove_advertisement_from_cart: function (advertisement_pk) {
        $.post(
          '/dashboard/winkelwagen/verwijderen/',
          {
            'estate_offer': advertisement_pk,
          },
          function () {
            bp.dashboard.set_advertisement_state(advertisement_pk);
            bp.sessionstate.get_sessionstate();
            // The cart-toggle action buttons are a separate server-rendered block
            // with no ajax swap, so the reload is what refreshes the row.
            // (Restored: dropped during the bp.js bundle refactor.)
            location.reload();
          }
        );
      },
    };
  })(),
});

export {bp};
